import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { CargoCreditoService } from '../../../services/CargoCreditoService';

const CargoCreditoForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [tiposOptions, setTiposOptions] = useState([]);

  // Load tipos options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const tipos = await CargoCreditoService.obtenerTipos();
      if (isMounted && Array.isArray(tipos)) {
        setTiposOptions(tipos);
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await CargoCreditoService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
      id_cc_tipos: values.id_cc_tipos ? Number(values.id_cc_tipos) : values.id_cc_tipos,
    };
    return await CargoCreditoService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'cargo_credito',
      label: 'Clave',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. MANIOBRA',
      validators: [Validators.required('La clave es obligatoria')],
    },
    {
      name: 'cc_nombre',
      label: 'Descripción',
      type: 'text',
      col: 4,
      required: true,
      placeholder: 'Ej. Maniobra de Carga y Descarga',
      validators: [Validators.required('La descripción es obligatoria')],
    },
    {
      name: 'id_cc_tipos',
      label: 'Tipo',
      type: 'select',
      col: 4,
      required: true,
      options: tiposOptions,
      placeholder: 'Seleccionar tipo...',
      validators: [Validators.required('El tipo es obligatorio')],
    },
  ], [tiposOptions]);

  return (
    <CatalogForm
      title="Cargo / Crédito"
      subtitle="Administración de conceptos de cargos y créditos"
      fields={fields}
      initialValues={{
        cargo_credito: '',
        cc_nombre: '',
        id_cc_tipos: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Cargos"
    />
  );
};

export default CargoCreditoForm;
